export const fmtN = (n) => Math.round(n).toLocaleString("fr-CH");

export const fmt1 = (n) =>
    n.toLocaleString("fr-CH", {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1,
    });

export const fmt1Signed = (n) => (n >= 0 ? "+" : "") + fmt1(n);

/** fmt1 tolérant : "—" si la valeur est absente (null / undefined) */
export const fmt1OrDash = (n) =>
    n === null || n === undefined ? "—" : fmt1(n);

const MONTHS_FR = [
    "janvier",
    "février",
    "mars",
    "avril",
    "mai",
    "juin",
    "juillet",
    "août",
    "septembre",
    "octobre",
    "novembre",
    "décembre",
];

/** Retourne les n derniers mois sous la forme "mois année" (du plus ancien au plus récent) */
export const monthsBack = (n) => {
    const now = new Date();
    const arr = [];
    for (let i = n - 1; i >= 0; i--) {
        const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
        arr.push(`${MONTHS_FR[d.getMonth()]} ${d.getFullYear()}`);
    }
    return arr;
};
